// Monitoring-only device telemetry helper.
// Purposefully limited to coarse technical metadata.
// No fingerprinting, no user content, no cross-site tracking.

const DEVICE_KEY = "device_id_v1";

function generateUuid(): string {
    // Modern browsers
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
        return crypto.randomUUID();
    }

    // Fallback (very unlikely to be needed in your app)
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

export function getOrCreateDeviceId(): string {
    try {
        const existing = localStorage.getItem(DEVICE_KEY);
        if (existing) return existing;

        const id = generateUuid();
        localStorage.setItem(DEVICE_KEY, id);
        return id;
    } catch {
        // If localStorage is blocked, fall back to per-session id
        return generateUuid();
    }
}

export function buildTelemetryHeaders(): Record<string, string> {
    const deviceId = getOrCreateDeviceId();

    let screenValue = "";
    try {
        const w = window.screen?.width ?? 0;
        const h = window.screen?.height ?? 0;
        screenValue = `${w}x${h}`;
    } catch {
        screenValue = "";
    }

    let dprValue = "";
    try {
        dprValue = String(window.devicePixelRatio ?? "");
    } catch {
        dprValue = "";
    }

    const headers: Record<string, string> = {
        "X-Device-Id": deviceId
    };

    if (screenValue) headers["X-Screen"] = screenValue;
    if (dprValue) headers["X-DPR"] = dprValue;

    return headers;
}